/*
 * WarisCalculator Messages
 *
 * This contains all the text for the WarisCalculator component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  header: {
    id: 'app.containers.WarisCalculator.header',
    defaultMessage: 'Hitung Pembagian Waris',
  },
  header_precisely: {
    id: 'app.containers.WarisCalculator.header_precisely',
    defaultMessage: 'dengan Akurat',
  },
  description: {
    id: 'app.containers.WarisCalculator.description',
    defaultMessage: 'Lakukan perhitungan waris Islam secara otomatis',
  },
  cta: {
    id: 'app.containers.WarisCalculator.cta',
    defaultMessage: 'Hitung Sekarang'
  },
});
